import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'

type Props = {
  steps: string | string[]
}

const useStyles = makeStyles(() => ({
  breadcrumb: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    color: '#787878'
  }
}))

export default function Breadcrumb ({ steps }: Props): JSX.Element {
  const classes = useStyles()

  return (
    <Typography className={classes.breadcrumb}>{typeof steps === 'object' ? steps.join('  > ') : steps}</Typography>
  )
}
